import React from "react";
import { connect } from "react-redux";
import "firebase/functions";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Link } from "react-router-dom";

import {
    Button,
    Typography,
    CircularProgress,
    withStyles,
    MenuItem,
    TextField,
    Snackbar,
    SnackbarContent,
    Grid,
    FormControl,
    Table,
    InputLabel,
    Select,
    Input,
    TableBody,
    TableHead,
    TableCell,
    TablePagination,
    TableRow,
    Card,
    CardContent,
    CardHeader
} from "@material-ui/core";

import {
    getRegisteredUsers,
    setNewUser,
    getQualifications,
    removeUser
} from "./actions";
import {
    selectRegisteredUsers,
    selectUsersRequesting,
    selectQualifications,
    selectUserIsRemoved
} from "./selectors";

import IconButton from "@material-ui/core/IconButton";

import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";

const styles = () => ({
    addUserModel: {
        width: "60%"
    },
    list: {
        width: "100%",
        marginTop: 15,
        marginBottom: 1,
        borderRadius: 5,
        backgroundColor: "#3f51b5"
    },
    listItem: {
        width: "auto",
        backgroundColor: "white",
        marginLeft: 10,
        marginRight: 10,
        borderRadius: 5,
        marginBottom: 1,
        marginTop: 1,
        padding: 0
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto"
    },
    form: {
        position: "relative",
        width: "90%"
    },
    progress: {
        position: "fixed",
        left: "50%",
        top: "50%",
        zIndex: 200
    }
});

class UserManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 50,
            newUserModal: false,
            activeStep: 0,
            removeUserModel: false,
            password: "",
            removeUID: false,
            showPassword: false,
            removeSuccess: false,
            addedSuccess: false,
            new_user: {
                access_level: "Level 4",
                account_created: "",
                agreed_to_eula: "No",
                agreed_to_eula_timestamp: "",

                direct_or_subcontractor: "Direct",
                email: "",
                phone_number: "",
                address: "",

                first_name: "",
                job_title: "",
                last_active: "",
                last_name: "",
                level_of_experience_in_similar_industry: "0",

                profile_image_url: "",

                security_level: "User",

                uid: "",
                years_in_present_position: "0"
            },
            canSubmit: true
        };
        props.getQualifications();
        props.getRegisteredUsers();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.removeUserModal !== this.props.removingUser) {
            this.setState({ removeUserModal: this.props.removingUser });
        }
    }
    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };
    handlePassChange = prop => event => {
        this.setState({ [prop]: event.target.value });
        this.canSubmit();
    };
    handleFormGrid() {
        const { new_user } = this.state;
        const { classes } = this.props;
        return (
            <Grid container spacing={8}>
                <Grid item md={6} xs={12}>
                    {this.renderTextDetail("First Name", "first_name")}
                    {this.renderTextDetail("Last Name", "last_name")}
                    {this.renderTextDetail("Job Title", "job_title")}
                    {this.renderTextDetail("Address", "address")}
                    {this.renderTextDetail("Email", "email")}
                    {this.renderTextDetail("Phone Number", "phone_number")}
                    <FormControl>
                        <InputLabel htmlFor="adornment-password">
                            Password
                        </InputLabel>
                        <Input
                            id="adornment-password"
                            type={this.state.showPassword ? "text" : "password"}
                            value={this.state.password}
                            onChange={this.handlePassChange("password")}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Toggle password visibility"
                                        onClick={this.handleClickShowPassword}
                                    >
                                        {this.state.showPassword ? (
                                            <Visibility />
                                        ) : (
                                            <VisibilityOff />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                    {this.renderTextDetail(
                        "Years in Present Position",
                        "years_in_present_position"
                    )}
                    {this.renderTextDetail(
                        "Level of Experience",
                        "level_of_experience_in_similar_industry"
                    )}
                    <div>
                        <FormControl className={classes.form}>
                            <InputLabel>Access Level</InputLabel>
                            <Select
                                value={new_user["access_level"]}
                                onChange={val => {
                                    new_user["access_level"] = val.target.value;
                                    this.setState({ new_user });
                                }}
                            >
                                <MenuItem value={"Level 0"}>Level 0</MenuItem>
                                <MenuItem value={"Level 1"}>Level 1</MenuItem>
                                <MenuItem value={"Level 2"}>Level 2</MenuItem>
                                <MenuItem value={"Level 3"}>Level 3</MenuItem>
                                <MenuItem value={"Level 4"}>Level 4</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl className={classes.form}>
                            <InputLabel>Access Level</InputLabel>
                            <Select
                                value={new_user["security_level"]}
                                onChange={val => {
                                    new_user["security_level"] =
                                        val.target.value;
                                    this.setState({ new_user });
                                }}
                            >
                                <MenuItem value={"User"}>User</MenuItem>
                                <MenuItem value={"Admin"}>Admin</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div>
                        <FormControl className={classes.form}>
                            <InputLabel>Direct or Subcontractor</InputLabel>
                            <Select
                                value={new_user["direct_or_subcontractor"]}
                                onChange={val => {
                                    new_user["direct_or_subcontractor"] =
                                        val.target.value;
                                    this.setState({ new_user });
                                }}
                            >
                                <MenuItem value={"Direct"}>Direct</MenuItem>
                                <MenuItem value={"Subcontractor"}>
                                    Subcontractor
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </Grid>
            </Grid>
        );
    }

    renderTextDetail(label, key) {
        const { new_user } = this.state;
        const { classes } = this.props;
        return (
            <TextField
                key={key}
                value={new_user[key]}
                label={label}
                className={classes.textField}
                onChange={val => {
                    new_user[key] = val.target.value;
                    this.setState({ new_user });
                    this.canSubmit();
                }}
            />
        );
    }

    onFormSubmit = () => {
        const { new_user } = this.state;
        const { qualifications } = this.props;
        let d = new Date();
        let date = `${("00" + d.getDate()).slice(-2)}-${(
            "00" +
            d.getMonth() +
            1
        ).slice(-2)}-${d.getFullYear()} ${("00" + d.getHours()).slice(-2)}:${(
            "00" + d.getMinutes()
        ).slice(-2)}:${("00" + d.getSeconds()).slice(-2)}`;
        let quals = {};
        if (qualifications) {
            Object.keys(qualifications).map(e => {
                quals[e] = {
                    qualification_category:
                        qualifications[e].qualification_category,
                    qualification_desc: qualifications[e].qualification_desc,
                    qualification_exp_date:
                        qualifications[e].expiry_date_required === true
                            ? "Req."
                            : "N/A",
                    qualification_id: qualifications[e].qualification_id,
                    qualification_img:
                        qualifications[e].qualification_image_required === true
                            ? ""
                            : "N/A",
                    qualification_invalid_img:
                        qualifications[e].qualification_invalid_img,
                    qualification_prefix:
                        qualifications[e].qualification_prefix,
                    qualification_reg_num:
                        qualifications[e].reg_number_required === true
                            ? ""
                            : "N/A",
                    qualification_title: qualifications[e].qualification_title,
                    qualification_valid_img:
                        qualifications[e].qualification_valid_img,
                    qualification_verified:
                        qualifications[e]
                            .qualification_verification_required === true
                            ? "No"
                            : "N/A"
                };
                return true;
            });
        }
        new_user["qualifications_per_user"] = quals;
        new_user["account_created"] = date;
        new_user["last_active"] = date;
        this.props.setNewUser(new_user, this.state.password, success => {
            if (success) this.setState({ addedSuccess: true });
        });
        this.handleCloseUserModal();
        this.props.getRegisteredUsers();
    };
    handleFormReset = () => {
        const { new_user } = this.state;
        new_user["first_name"] = "";
        new_user["last_name"] = "";
        new_user["phone_number"] = "";
        new_user["job_title"] = "";
        new_user["email"] = "";
        new_user["years_in_present_position"] = "0";
        new_user["level_of_experience_in_similar_industry"] = "0";
        new_user["access_level"] = "Level 4";
        new_user["security_level"] = "Admin";
        new_user["direct_or_subcontractor"] = "Direct";
        this.setState({ new_user });
        this.setState({ password: "" });
    };
    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    canSubmit() {
        if (
            this.state.password.length >= 5 &&
            this.validateEmail(this.state.new_user.email)
        )
            this.setState({ canSubmit: false });
        else this.setState({ canSubmit: true });
    }
    renderTextAreaDetail(label, key) {
        const { new_user } = this.state;
        const { classes } = this.props;

        return (
            <div>
                <TextField
                    key={key}
                    value={new_user[key]}
                    label={label}
                    multiline={true}
                    rows={2}
                    rowsMax={4}
                    className={classes.textField}
                    onChange={val => {
                        new_user[key] = val.target.value;
                        this.setState({ new_user });
                    }}
                />
            </div>
        );
    }

    renderYesNoDetail(label, key) {
        const { new_user } = this.state;
        const { classes } = this.props;
        return (
            <FormControl className={classes.form}>
                <InputLabel>{label}</InputLabel>
                <Select
                    key={key}
                    value={new_user[key]}
                    onChange={val => {
                        new_user[key] = val.target.value;
                        this.setState({ new_user });
                    }}
                >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                </Select>
            </FormControl>
        );
    }
    renderDateDetail(label, key) {
        const { new_user } = this.state;
        const { classes } = this.props;
        let date = new_user[key].split("-");
        let dt = `${date[2]}-${date[0]}-${date[1]}`;
        return (
            <div className={classes.form}>
                {/* <InputLabel className={classes.picker}>{label}</InputLabel>
                <p /> */}
                <TextField
                    id="date"
                    label={label}
                    type="date"
                    defaultValue={new Date()}
                    value={dt}
                    onChange={event => {
                        new_user[key] = event.target.value;

                        this.setState({ new_user });
                    }}
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            </div>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    handleNewUserModal = () => {
        this.handleFormReset();
        this.setState({ newUserModal: true });
    };

    handleCloseUserModal = () => {
        this.setState({ newUserModal: false });
    };
    handleRemoveUserModal = () => {
        this.setState({ removeUserModal: true });
    };
    handleCloseRemoveUserModal = () => {
        this.setState({ removeUserModal: false });
    };
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render() {
        const users = this.props.users === [] ? false : this.props.users;
        const { classes } = this.props;
        const { rowsPerPage, page } = this.state;

        return (
            <Card>
                <CardHeader title="User Manager" />
                <CardContent>
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Button
                                            onClick={this.handleNewUserModal}
                                            color="primary"
                                            variant="contained"
                                        >
                                            Add New User
                                        </Button>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={12}
                                        ActionsComponent={TablePaginationHelper}
                                        count={users.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={
                                            this.handleChangeRowsPerPage
                                        }
                                        rowsPerPageOptions={[50, 100]}
                                    />
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        <Typography variant="body2">
                                            <b>Full Name</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Account Created</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Last Active</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Email Address</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Phone Number</b>
                                        </Typography>
                                    </TableCell>

                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Security Level</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Access Level</b>
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">
                                            <b>Action</b>
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {users
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    .map((e, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    <Typography variant="body1">
                                                        {e.first_name}{" "}
                                                        {e.last_name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.account_created}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.last_active}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {e.email}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {typeof e.phone_number ===
                                                        "undefined"
                                                            ? "000 000 0000"
                                                            : e.phone_number}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {typeof e.security_level ===
                                                        "undefined"
                                                            ? "Unknown Access"
                                                            : e.security_level}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="body1">
                                                        {typeof e.access_level ===
                                                        "undefined"
                                                            ? "Unknown Access"
                                                            : e.access_level}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <div
                                                        style={{
                                                            display:
                                                                "inline-flex"
                                                        }}
                                                    >
                                                        <Link
                                                            to={`/user-profile-view/${
                                                                e.uid
                                                            }`}
                                                        >
                                                            <IconButton
                                                                style={{
                                                                    border:
                                                                        "1px solid blue",
                                                                    color:
                                                                        "blue",
                                                                    marginRight:
                                                                        "10px"
                                                                }}
                                                            >
                                                                <ViewIcon />
                                                            </IconButton>
                                                        </Link>
                                                        <IconButton
                                                            style={{
                                                                border:
                                                                    "1px solid red",
                                                                color: "red"
                                                            }}
                                                            aria-label="Delete"
                                                            onClick={() => {
                                                                this.setState({
                                                                    removeUID:
                                                                        e.uid
                                                                });
                                                                this.handleRemoveUserModal();
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                        {this.props.userReq && (
                            <div>
                                <CircularProgress
                                    className={classes.progress}
                                />
                            </div>
                        )}
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.newUserModal}
                            className={classes.addUserModal}
                        >
                            <ModalHeader>Add New User</ModalHeader>
                            <ModalBody>{this.handleFormGrid()}</ModalBody>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => this.handleFormReset()}
                                        className={classes.backButton}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        onClick={this.handleCloseUserModal}
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onFormSubmit}
                                        disabled={this.state.canSubmit}
                                    >
                                        Add User
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Modal
                            isOpen={this.state.removeUserModal}
                            className={classes.addUserModal}
                        >
                            <ModalHeader>Remove User</ModalHeader>
                            <ModalBody>
                                <Typography variant="body2">
                                    Are you you sure you want to remove this
                                    user?
                                </Typography>
                            </ModalBody>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={
                                            this.handleCloseRemoveUserModal
                                        }
                                        className={classes.backButton}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.removeUser(
                                                this.state.removeUID,
                                                success => {
                                                    if (success) {
                                                        this.setState({
                                                            removeSuccess: true
                                                        });
                                                    }
                                                }
                                            );
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        autoHideDuration={6000}
                        open={this.state.removeSuccess}
                        onClose={() => {
                            this.setState({ removeSuccess: false });
                        }}
                    >
                        <SnackbarContent
                            style={{ backgroundColor: "green", color: "white" }}
                            message="User has been successfully removed!"
                        />
                    </Snackbar>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left"
                        }}
                        autoHideDuration={6000}
                        open={this.state.addedSuccess}
                        onClose={() => {
                            this.setState({ addedSuccess: false });
                        }}
                    >
                        <SnackbarContent
                            style={{ backgroundColor: "green", color: "white" }}
                            message="User has been successfully added!"
                        />
                    </Snackbar>
                </CardContent>
            </Card>
        );
    }
}

export default connect(
    store => {
        return {
            users: selectRegisteredUsers(store),
            userReq: selectUsersRequesting(store),
            qualifications: selectQualifications(store),
            removingUser: selectUserIsRemoved(store)
        };
    },
    { getRegisteredUsers, setNewUser, getQualifications, removeUser }
)(withStyles(styles)(UserManager));
